import { createFileRoute } from "@tanstack/react-router";
import { faqPageScript, i18nLinks, i18nOgMeta, localeUrl } from "@/lib/seo";
import { m } from "@/paraglide/messages";
import { TimerIndex } from "@/tools/timer/pages/TimerIndex";

export const Route = createFileRoute("/timer/")({
  ssr: true,
  head: () => ({
    meta: [
      { title: m.timer_hub_meta_title() },
      { name: "description", content: m.timer_hub_meta_description() },
      { property: "og:title", content: m.timer_hub_meta_title() },
      { property: "og:description", content: m.timer_hub_meta_description() },
      ...i18nOgMeta("/timer"),
    ],
    links: [...i18nLinks("/timer")],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: m.timer_breadcrumb_home(),
              item: localeUrl(`/`),
            },
            {
              "@type": "ListItem",
              position: 2,
              name: m.timer_tool_name(),
              item: localeUrl(`/timer`),
            },
          ],
        }),
      },
      faqPageScript([
        { q: m.timer_hub_faq1_q(), a: m.timer_hub_faq1_a() },
        { q: m.timer_hub_faq2_q(), a: m.timer_hub_faq2_a() },
        { q: m.timer_hub_faq3_q(), a: m.timer_hub_faq3_a() },
        { q: m.timer_hub_faq4_q(), a: m.timer_hub_faq4_a() },
      ]),
    ],
  }),
  component: TimerIndex,
});
